"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismantleStrategy = exports.DismantleStatus = void 0;
var DismantleStatus;
(function (DismantleStatus) {
    DismantleStatus["ACTIVE"] = "ACTIVE";
    DismantleStatus["INACTIVE"] = "INACTIVE";
})(DismantleStatus || (exports.DismantleStatus = DismantleStatus = {}));
var DismantleStrategy;
(function (DismantleStrategy) {
    DismantleStrategy["FLAT"] = "FLAT";
    DismantleStrategy["LINEAR"] = "LINEAR";
    DismantleStrategy["EXPONENTIAL"] = "EXPONENTIAL";
})(DismantleStrategy || (exports.DismantleStrategy = DismantleStrategy = {}));
//# sourceMappingURL=dismantle.js.map